enum PackRequestTypes {
  RequestPack = 1,
  RequestPackRenewal = 2,
  RequestExtraLicenses = 3,
  RequestTrialConvert = 4,
}

export default PackRequestTypes;
